import { LayoutGrid, Table } from "lucide-react";
import { cn } from "@/lib/utils";
import type { ObjectivesView } from "@/router";

interface ObjectivesViewToggleProps {
  value: ObjectivesView;
  onChange: (next: ObjectivesView) => void;
}

const OPTIONS: Array<{ value: ObjectivesView; label: string; Icon: typeof LayoutGrid }> = [
  { value: "cards", label: "Cards", Icon: LayoutGrid },
  { value: "table", label: "Table", Icon: Table },
];

export function ObjectivesViewToggle({ value, onChange }: ObjectivesViewToggleProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Objective view"
      className="inline-flex rounded-md border border-[hsl(var(--border))] bg-[hsl(var(--background))] p-0.5"
    >
      {OPTIONS.map(({ value: optValue, label, Icon }) => {
        const active = value === optValue;
        return (
          <button
            key={optValue}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(optValue)}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-[5px] px-2.5 py-1 text-xs font-medium transition-colors",
              active
                ? "bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))]"
                : "text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))]",
            )}
          >
            <Icon className="h-3 w-3" aria-hidden="true" />
            {label}
          </button>
        );
      })}
    </div>
  );
}
